module.exports = __webpack_public_path__ + "static/media/21ECLAC22.534dfff9.jpg";